import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const GoogleDriveLogoBottomBlueIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M2048 1354l-323 566H487l322-566h1239z" />
    </svg>
  ),
  displayName: 'GoogleDriveLogoBottomBlueIcon',
});

export default GoogleDriveLogoBottomBlueIcon;
